import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    dot: 'h-1.5 w-1.5 cursor-pointer rounded-full transition-all duration-300'
  }
});
